import type { SxProps, Theme } from '@mui/material/styles';

export const rootSx =
  (disabled?: boolean, hasOnClick?: boolean): SxProps<Theme> =>
  theme => ({
    width: '100%',
    color: disabled ? theme.palette.action.disabled : theme.palette.primary.main,
    lineHeight: theme.typography.body1.lineHeight,
    letterSpacing: theme.typography.h1.letterSpacing,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.body1.fontWeight,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 0.5,
    borderRadius: 1,
    px: 0.25,

    '&:hover, &:has(.Mui-focusVisible)': {
      backgroundColor: disabled || !hasOnClick ? 'inherit' : 'rgba(0,0,0,0.04)',
      cursor: disabled || !hasOnClick ? 'auto' : 'pointer',
    },
  });

// Resets the native button look so the action keeps the row's layout and typography
export const actionSx: SxProps<Theme> = {
  minWidth: 0,
  justifyContent: 'flex-start',
  gap: 0.5,
  textAlign: 'left',
  font: 'inherit',
  letterSpacing: 'inherit',
  borderRadius: 'inherit',
  cursor: 'inherit',
};

export const iconContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0',
  minWidth: 36,
  minHeight: 36,
  width: 'fit-content',
};
